@if (!deviceService.isRobot) {
    @if (width && height) {
        <fast-svg [name]="name" [width]="width" [height]="height" [class]="extraClass"></fast-svg>
    } @else {
        <fast-svg [name]="name" [size]="size" [class]="extraClass"></fast-svg>
    }
}
